import React from 'react';
import Skills from './Skills';

const Skillset = () => {
    return (
        <>
            <h1 className='SkillsHeading' style={{marginTop:'100px'}}> <b>Professional </b> Skillset</h1>
            <div className='skills'>
        
                <Skills skill='React' />
                <Skills skill='Redux' />
                <Skills skill='Node' />
                <Skills skill='Express' />
                <Skills skill='MongoDb' />
                <Skills skill='Github' />
                <Skills skill='Javascript' />
                <Skills skill='NPM' />
                <Skills skill='Html' />
                <Skills skill='Postman' />
                <Skills skill='Docker' />
                <Skills skill='CSS' />
                <Skills skill='Bootstrap'/>
                <Skills skill='Azure' />
                <Skills skill='Git' />
                <Skills skill='Typescript' />
                <Skills skill='MySQL' />
                <Skills skill='Android' />
                <Skills skill='VisualStudio' />
                <Skills skill='Sass' />
                <Skills skill='GoogleColab' />
                <Skills skill='Python' />
                <Skills skill='Streamlit' />
                <Skills skill='jQuery' />
                <Skills skill='AWS' />
                <Skills skill='Mapreduce' />
                <Skills skill='Postgresql' />
                <Skills skill='R' />
                <Skills skill='C' />
                <Skills skill='Cplusplus' />
                <Skills skill='Linux' />
                <Skills skill='GraphQl' />
                <Skills skill='Pandas' />
                <Skills skill='PyTorch' />
                <Skills skill='Tensorflow' />
                <Skills skill='Keras' />
                <Skills skill='Numpy' />
                <Skills skill='Jest' />
                <Skills skill='Scikitlearn' />
                




                
            </div>
        </>
    );
};

export default Skillset;